// Converted from application/views/expositions_v.php. Edit this component directly.
export default function ExpositionsPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<a href={"/c/sculpture/mother&child-marble"}>
<img src={"/assets/images/sculptures/mother&child/marble/Mother&Child-marble-cover.jpg"} alt={"Mother & Child at Museo degli Innocenti, Florence"} />
</a>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1 style={{"marginBottom":"3rem"}}>{"Expositions"}</h1>
<ul>
<li>
<a href={"/c/exhibitions"}>{"Exhibitions"}</a>
</li>
<li>
<a href={"/c/commissions"}>{"Commissions"}</a>
</li>
<li>
<a href={"/c/scenarios"}>{"Scenarios"}</a>
</li>
</ul>
</div>
</div>
</div>
</div>
<div class={"container"} style={{"margin":"0 2rem","flexDirection":"column"}}>
<h2 style={{"textAlign":"center"}}>{"Poetry of Life"}</h2>
<blockquote style={{"margin":"2rem auto 4rem auto"}}>
<p>{"I dream that this, which I create, will replicate"}<br />{"\n        the poetry of life which breathes inside you."}<br />{"\n        Just once more let me pour my soul into this shape"}<br />{"\n        to make you whole again.\n    "}</p>
<footer>{"—Paddy Campbell"}</footer>
</blockquote>
</div>
</>;
}
